import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  paddingTop: 0,
};

export const contentSx: SxStyle = {
  maxHeight: 'unset',
  paddingTop: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  gap: (p) => p.spacing(1),
  mt: (p) => p.spacing(1),
};

export const iconBox: SxStyle = {
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.grey[300],
  borderRadius: (p) => p.spacing(0.5),
  width: (p) => p.spacing(3.5),
  height: (p) => p.spacing(3.5),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  ' &:hover ': {
    backgroundColor: (p) => p.palette.grey[300],
  },
};
